import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
    getPagingPost,
    callCreatePost,
    callCreatePostBulk,
    callUpdatePost,
    callDeletePost,
} from "@/services/ophim69Service";

interface PostMeta {
    page: number; // pageIndex
    limit: number; // pageSize
    totalPages: number;
    totalItems: number;
}

interface PostState {
    // State
    isLoading: boolean;
    meta: PostMeta;
    result: any[];
    posts: any[];
    error?: string | null;

    // Actions
    fetchPosts: (params?: {
        domainIds?: string[];
        pageIndex?: number;
        pageSize?: number;
        search?: string;
    }) => Promise<void>;
    createPost: (data: { domain_id: string; movie_id: string }) => Promise<any>;
    createPostBulk: (data: { domain_ids: string[]; movie_ids: string[] }) => Promise<any>;
    updatePost: (id: string, data: FormData) => Promise<any>;
    deletePost: (id: string) => Promise<any>;
    setPage: (page: number) => void;
}

export const usePostStore = create<PostState>()(
    persist(
        (set, get) => ({
            // Initial state
            isLoading: true,
            meta: {
                page: 1,
                limit: 10,
                totalPages: 0,
                totalItems: 0,
            },
            result: [],
            posts: [],
            error: null,

            // Fetch posts (paging)
            fetchPosts: async (params = {}) => {
                set({ isLoading: true, error: null });
                try {
                    const response: any = await getPagingPost({ params });
                    // Hỗ trợ nhiều cấu trúc trả về khác nhau
                    const payload = response?.data ?? response;
                    const meta = payload?.meta ?? payload?.data?.meta ?? {};
                    const result = payload?.result ?? payload?.data?.result ?? [];

                    set({
                        isLoading: false,
                        meta: {
                            page: meta.pageIndex ?? meta.page ?? get().meta.page,
                            limit: meta.pageSize ?? meta.limit ?? get().meta.limit,
                            totalPages: meta.totalPages ?? 0,
                            totalItems: meta.totalItems ?? 0,
                        },
                        result,
                        posts: result,
                    });
                } catch (error: any) {
                    set({ isLoading: false, error: error?.message || "Lỗi tải danh sách post" });
                }
            },

            createPost: async (data) => {
                const res: any = await callCreatePost(data);
                // Tải lại danh sách theo trang hiện tại
                const { page, limit } = get().meta;
                await get().fetchPosts({ pageIndex: page, pageSize: limit });
                return res;
            },

            createPostBulk: async (data) => {
                const res: any = await callCreatePostBulk(data);
                const { page, limit } = get().meta;
                await get().fetchPosts({ pageIndex: page, pageSize: limit });
                return res;
            },

            updatePost: async (id, data) => {
                const res: any = await callUpdatePost(id, data);
                const { page, limit } = get().meta;
                await get().fetchPosts({ pageIndex: page, pageSize: limit });
                return res;
            },

            deletePost: async (id) => {
                const res: any = await callDeletePost(id);
                const { page, limit } = get().meta;
                await get().fetchPosts({ pageIndex: page, pageSize: limit });
                return res;
            },

            setPage: (page) => {
                set((state) => ({ meta: { ...state.meta, page } }));
            },
        }),
        {
            name: "post-storage",
            partialize: (state) => ({
                meta: state.meta,
            }),
        }
    )
);


